import React from 'react'

const RestarantsMaster = () => {
  return (
    <div>RestarantsMaster</div>
  )
}

export default RestarantsMaster